import React from 'react'
import { ResponsiveContainer, AreaChart, CartesianGrid, XAxis, YAxis, Tooltip, Area } from 'recharts'
import { useRecoilValue } from 'recoil'
import { analyticData } from '../../../recoil/analytic'

const ScoreChart = () => {
  const analytic = useRecoilValue(analyticData);

  const data = analytic.score_data.map(item => {
    return { score: item.score, 'Jumlah': item.count};
  })

  return (
    <div className='w-full h-72'>
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart
          width={500}
          height={300}
          data={data}
          margin={{
            top: 5,
            right: 30,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3"/>
          <XAxis dataKey="score"/>
          <YAxis/>
          <Tooltip/>
          <Area dataKey="Jumlah" stroke='#0284C7' fill='#E0F2FE' strokeWidth={2}/>
        </AreaChart>
      </ResponsiveContainer>
    </div>
  )
}

export default ScoreChart